import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { C, KPIS_BASE } from "./constants";

function Spark({ color, up }) {
  const pts = up
    ? [[0,22],[10,18],[20,20],[30,14],[40,16],[50,10],[60,12],[70,4]]
    : [[0,4],[10,8],[20,5],[30,10],[40,8],[50,14],[60,11],[70,18]];
  const d = pts.map((p,i) => `${i===0?"M":"L"}${p[0]} ${p[1]}`).join(" ");
  return (
    <svg width={70} height={26} viewBox="0 0 70 26" fill="none">
      <path d={`${d} L70 26 L0 26 Z`} fill={color} opacity={0.13}/>
      <path d={d} stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}


export default function KPICard({
  label, val, color, bg, Icon, trend, chip, sub, up,
  period, onPeriodChange, cRange, onRangeChange,
  filterRatio, onCountClick
}) {
  const dispVal = Math.round((val ?? 0) * (filterRatio ?? 1));
  const total = KPIS_BASE.reduce((s, k) => s + (k.val || 0), 0);
  const pct   = total > 0 ? Math.round((dispVal / total) * 100) : 0;
  const tC  = trend === "up" ? "#10B981" : trend === "dn" ? C.red : "#94A3B8";
  const TrI = trend === "up" ? ArrowUpRight : trend === "dn" ? ArrowDownRight : Minus;

  return (
    <div
      className="bg-white rounded-[18px] relative transition-[transform,box-shadow] duration-[220ms] cursor-default"
      style={{ border:`1.5px solid ${color}1A` }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = `0 16px 36px ${color}22`;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "none";
      }}>

      <div className="absolute inset-0 rounded-[18px] overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-1" style={{ background:`linear-gradient(90deg,${color}55,${color})` }}/>
        <div className="absolute -top-5 -right-5 w-[86px] h-[86px] rounded-full opacity-80" style={{ background:bg }}/>
      </div>

      <div className="relative p-4 pb-[13px] flex flex-col">

        <div className="flex items-start justify-between mb-2">
          <div className="flex-1 mr-2">
            <div className="text-[9px] font-bold uppercase tracking-[.8px] text-[#94A3B8]">{label}</div>
          </div>
          <div className="w-9 h-9 rounded-[10px] shrink-0 flex items-center justify-center" style={{ background:bg }}>
            <Icon size={14} color={color} strokeWidth={1.8}/>
          </div>
        </div>

        <div className="flex items-end justify-between mb-[9px]">
          <div
            onClick={onCountClick}
            className={`text-[32px] font-extrabold tracking-[-1.5px] leading-none ${onCountClick ? "cursor-pointer" : "cursor-default"}`}
            style={{ color }}>
            {dispVal.toLocaleString()}
          </div>
          <Spark color={color} up={up}/>
        </div>

        <div className="inline-flex items-center gap-1 px-[9px] py-[3px] rounded-[30px] text-[10.5px] font-bold mb-[11px] self-start" style={{ background:`${tC}12`, color:tC }}>
          <TrI size={10} strokeWidth={2.5}/><span>{chip} {sub}</span>
        </div>

        <div className="h-1 rounded-full overflow-hidden" style={{ background:`${color}12` }}>
          <div className="h-full rounded-full" style={{ width:`${pct}%`, background:`linear-gradient(90deg,${color}60,${color})` }}/>
        </div>
        <div className="flex justify-between mt-1">
          <span className="text-[8.5px] text-[#B0BAC9] font-medium">Share of tasks</span>
          <span className="text-[8.5px] font-bold" style={{ color:`${color}99` }}>{pct}%</span>
        </div>

      </div>
    </div>
  );
}